import swal from 'sweetalert'
import { getJquery } from '../js/util'

let $ = getJquery()

export default {
	init() {
		let $protectedWrap = $('.category-protected')
		if ($protectedWrap.length) {
			protectedPage()
		}
	},
	finalize() {},
}

function protectedPage() {
	let { swal, localStorage } = window
	let { promoterExpiry } = localStorage
	let date = new Date()
	let currentTime = date.getTime()
	// block if not logged in
	if (!$('.logged-in').length) {
		swal({
			title: 'Restricted',
			text: 'Please register or log in to access promoter products',
			icon: 'error',
			button: {
				text: 'Close',
				closeModal: true,
			},
		})
		return
	}
	//
	function showDisclaimer() {
		const wrapper = document.createElement('div')
		wrapper.innerHTML = `
      <p>1. Products offered can only be sold and demoed at approved classes.</p>
      <p>2. Most products will have a 30-40% discount for you, we  suggest you stick to website pricing when reselling the products. If you want to give class discounts, that is at your discretion.</p>
      <p>3. When returning products that did not sell they must be UNOPENED  and in the same condition they arrived to you. They also must be shipped out within 7 days after the date of your class. <br>
      Return Address: <br>
      ProFiles Backstage <br>
      Attn: Class Return <br>
      2323 Del Prado Blvd #8 <br>
      Cape Coral FL 33990</p>
      <p>4. Sample sizes are prepared special for each class, therefore they cannot be returned for a refund.</p>
      <p>5. Some product bundles may not be eligible for full refund, but it will clearly state this in the product descriptions.</p>
      <p>6. We will help promote your class by social media and or put your class on our website. If you are using another company name we can not put you on the calendar, but we will help through our instagram and facebook posts.</p>
      <p>If you are only announcing PF Products we will put you on our events calendar on our website with a link to your registration.</p>
      <p>7. You can receive free demo products by purchasing moq's of that specific product, each product will vary and you can find the eligibility for free demo products in the description of the each product.</p>
      <p>8. Product knowledge cards will automatically be included with applicable products. Again, products descriptions will let you know if you can expect to receive cards.</p>
    `
		swal({
			title: 'Promoter Disclaimer',
			content: wrapper,
			closeOnClickOutside: false,
			closeOnEsc: false,
			button: {
				text: 'Agree',
				closeModal: true,
			},
		})
		$('.swal-overlay')[0].scrollTop = 0
		$('.swal-modal').css({
			width: '800px',
			maxWidth: '98%',
		})
	}
	$('.disclaimer-btn').on('click', showDisclaimer)

	// show code popup if needed
	if (!promoterExpiry || promoterExpiry < currentTime) {
		showPromoterCodePopup(promoterExpiry, currentTime, showDisclaimer)
	} else {
		// console.log('gap', promoterExpiry - currentTime)
		$('.category-protected').removeClass('category-protected')
	}
}

function showPromoterCodePopup(promoterExpiry, currentTime, showDisclaimer) {
	let { swal, wpApiSettings } = window

	swal({
		title: 'Restricted',
		text: 'Enter your code below to access promoter products',
		content: 'input',
		icon: 'error',
		button: {
			text: 'Submit',
			closeModal: false,
		},
	})
		.then((code) => {
			if (!code) throw null
			return fetch(`${wpApiSettings.root}prof/v1/protected?code=${code}`, {
				credentials: 'same-origin',
				headers: {
					'X-WP-Nonce': wpApiSettings.nonce,
				},
			})
		})
		.then((results) => {
			return results.json()
		})
		.then((res) => {
			if (res.success && res.expiryTime * 1000 > currentTime) {
				//  and check against expiry
				// add exipiry time to localstorage
				window.localStorage.promoterExpiry = res.expiryTime * 1000
				$('#woverlay').fadeOut(999)
				$('.category-protected').addClass('show-cat')
				swal({
					icon: 'success',
					title: 'Welcome',
					closeOnEsc: false,
					closeOnClickOutside: false,
					text: `You have access to promoter products until your class date on ${res.expiry}`,
					button: {
						text: 'View Products',
						closeModal: false,
					},
				}).then(showDisclaimer)
			} else {
				swal({
					icon: 'error',
					title: 'Incorrect Code',
					text: 'Your code is expired or was entered incorrectly.',
					button: {
						text: 'Try Again',
						closeModal: true,
					},
				}).then(() => setTimeout(protectedPage, 200))
			}
		})
		.catch((err) => {
			if (err) {
				swal('Error', 'The request failed', 'error')
			} else {
				swal.stopLoading()
				swal.close()
			}
		})
}
